export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function normalizeApiErrorMessage(message, status) {
  const raw = (message || '').trim();
  const lower = raw.toLowerCase();

  if (lower.includes('<!doctype') || lower.includes('<html') || lower.includes('bad gateway') || status === 502 || status === 504) {
    return 'The server took longer than the gateway allows. The analysis keeps running in the background — wait a moment and it will appear automatically.';
  }
  if (raw.length > 300) {
    return `${raw.slice(0, 220)}…`;
  }

  if (!raw || lower === 'request failed') {
    return "We couldn't complete this action right now. Please try again.";
  }

  if (lower.includes('failed to fetch') || lower.includes('networkerror')) {
    return 'Connection to the server was lost. Please try again in a moment.';
  }

  if (lower.includes('blocked') || lower.includes('disrupted')) {
    return 'The request was interrupted. Please try again — if it was an image, try a sharper capture.';
  }

  if (status >= 500) {
    return raw || "The server couldn't complete this action. Please try again.";
  }

  return raw;
}

export async function apiRequest(path, options = {}) {
  let response;
  try {
    response = await fetch(`${BACKEND_URL}${path}`, options);
  } catch (error) {
    const err = new Error(normalizeApiErrorMessage(error.message || 'Request failed', 0));
    err.status = 0;
    throw err;
  }

  const contentType = response.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const data = isJson ? await response.json() : null;
  const text = isJson ? '' : await response.text().catch(() => '');

  if (!response.ok) {
    const err = new Error(normalizeApiErrorMessage(data?.detail || data?.message || text || 'Request failed', response.status));
    err.status = response.status;
    throw err;
  }

  return isJson ? data : text;
}

export function getMediaUrl(url) {
  if (!url) {
    return '';
  }

  if (url.startsWith('http')) {
    return url;
  }

  return `${BACKEND_URL}${url}`;
}